import React from 'react';
import {FormattedMessage} from 'react-intl';
import Totals from './totals';
import Filter from './filter';
import MainChart from './chart';
import MainTable from "./main-table";

export class Analytics extends React.Component {

  render() {
    const {
      metric, groups, labelType, labelValues, initialState, setInitialState,
      projects, osGroups, browserGroups, trafficChannels, affiliateNetworks, deviceTypes, country, cities,
      pageSize, currentPage, order, region
    } = this.props;
    let {dateFrom, dateTo} = this.props;
    dateFrom = dateFrom.utcOffset(0, true);
    dateTo = dateTo.utcOffset(0, true);
    return (<div className='page'>
      <Filter
        period={[dateFrom, dateTo]} onPeriodChange={this.props.onPeriodChange}
        metrics={[]}
        metric={metric} onMetricChange={this.props.onMetricChange}
        selected={groups}
        osGroupsSelected={osGroups}
        browserGroupsSelected={browserGroups}
        trafficChannelsSelected={trafficChannels}
        affiliateNetworksSelected={affiliateNetworks}
        deviceTypesSelected={deviceTypes}
        countrySelected={country}
        regionsSelected={region}
        citiesSelected={cities}
        onLeadGroupsChange={this.props.onLeadGroupsChange}
        onOsGroupsChange={this.props.onOsGroupsChange}
        onBrowserGroupsChange={this.props.onBrowserGroupsChange}
        onTrafficChannelsChange={this.props.onTrafficChannelsChange}
        onAffiliateNetworksChange={this.props.onAffiliateNetworksChange}
        onDeviceTypesChange={this.props.onDeviceTypesChange}
        onCountryChange={this.props.onCountryChange}
        onRegionChange={this.props.onRegionChange}
        onCitiesChange={this.props.onCitiesChange}
        onUrlLabelsChange={this.props.onUrlLabelsChange}
        labelType={labelType}
        labelValues={labelValues}
      />

      <Totals
          dateFrom={dateFrom} dateTo={dateTo}
          osGroups={osGroups}
          browserGroups={browserGroups}
          trafficChannels={trafficChannels}
          affiliateNetworks={affiliateNetworks}
          deviceTypes={deviceTypes}
          country={country}
          region={region}
          cities={cities}
          projects={projects}
          labelType={labelType}
          labelValues={labelValues}
      />


      <div style={{marginTop: '8px'}} className={'charts-row'}>
        <MainChart
          initialState={initialState['leads']}
          setInitialState={setInitialState}
          header={<FormattedMessage id='analytics.leads-by-period'/>}
          metric='leads'
          modes={['line', 'bar']}
          units={['percent', 'count']}
          dateFrom={dateFrom} dateTo={dateTo}
          groups={groups}
          osGroups={osGroups}
          browserGroups={browserGroups}
          trafficChannels={trafficChannels}
          affiliateNetworks={affiliateNetworks}
          deviceTypes={deviceTypes}
          country={country}
          region={region}
          cities={cities}
          projects={projects}
          labelType={labelType}
          labelValues={labelValues}
        />
      </div>

      <MainTable
        style={{marginTop: '8px'}}
        dateFrom={dateFrom} dateTo={dateTo}
        osGroups={osGroups}
        browserGroups={browserGroups}
        trafficChannels={trafficChannels}
        affiliateNetworks={affiliateNetworks}
        deviceTypes={deviceTypes}
        country={country}
        cities={cities}
        region={region}
        projects={projects}
        labelType={labelType}
        labelValues={labelValues}
        pageSize={pageSize}
        currentPage={currentPage}
        order={order}
        onTableChange={this.props.onTableChange}
      />
    </div>)
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/analytics/index.js